import { API_URL } from '../../../app-config/constants';
import type { CompanyDetailsDto } from '../../../types/CompanyDtos';
import type CompanyPaymentDto from '../../../types/CompanyPaymentDto';
import type { BILLING_LOCATION } from '../../../types/CustomerDto';
import { get, post } from '../request';

getCompany.operation = 'READ';
getCompany.byId = true;
export function getCompany(id: string) {
    return get<CompanyDetailsDto>(`${API_URL}/companies/${id}`);
}

activateNewBilling.operation = 'COMMAND';
export function activateNewBilling(id: string, location: BILLING_LOCATION, planId: string, mainContactId: string) {
    return post<CompanyDetailsDto>(
        `${API_URL}/billing/${id}/activate?location=${location}&planId=${planId}&mainContact=${mainContactId}`
    );
}

deactivateNewBilling.operation = 'COMMAND';
export function deactivateNewBilling(id: string) {
    return post<CompanyDetailsDto>(`${API_URL}/billing/${id}/deactivate`);
}

editBilling.operation = 'COMMAND';
export function editBilling(id: string, payload: CompanyPaymentDto) {
    return post<CompanyDetailsDto>(`${API_URL}/companies/${id}/billing`, { postData: payload });
}

interface MergeCompanyPayload {
    source: string;
    target: string;
    password: string;
}

mergeCompanies.operation = 'NO_OPERATION';
export function mergeCompanies(source: string, target: string, password: string) {
    return post<MergeCompanyPayload>(`${API_URL}/companies/merge`, { postData: { source, target, password } });
}
